export default Object.freeze({
  TITLE: '표준카테고리수수료 관리',
  TABLE_TIT: '카테고리 상세설정',
  EXALDOWN: '엑셀 다운로드',
  TAB_TIT: '설정',
  TABLE_TH1: '카테고리 경로',
  TABLE_TH2: '카테고리 번호',
  TABLE_TH3: '수수료',
  CATEGORY_ICON: '카테고리 아이콘',
  CATEGORY_ADULTS: '성인카테고리',
  CATEGORY_NAME: '카테고리명',
  CONFIG_INFO2: '카테고리 번호, URL은 최종 저장 후에 생성됩니다.',
  CATEGORY_NOTICE1: '카테고리 수수료는 최종적으로 [변경사항 수정] 버튼을 클릭 후 반영됩니다.',
  CATEGORY_NOTICE2: '[변경사항 수정] 버튼을 클릭하지 않고 쇼핑몰 탭을 이용하여 쇼핑몰 이동 시 이전에 설정한 수수료는 반영되지 않으니 \n반드시 [변경사항 수정] 버튼을 클릭해 주시기 바랍니다.',
  CATEGORY_NOTICE3: '엑셀 다운로드 시 전체 카테고리에 설정된 수수료를 확인할 수 있습니다.',

  SAVEBTN: '변경사항 저장',
  ADULTDEFALUT: '설정',
  SUCCESS_ALERT: '수정완료',
  ALCOHOL_CONFIRM: '수수료를 입력하지 않은 카테고리는 0.0%로 저장됩니다. 변경사항을 수정하시겠습니까?',
  NO_CONTENT: '변경내용이 없습니다.',
  CHANGE_MALL_ALERT: '저장되지 않은 내용이 있습니다. 쇼핑몰을 이동 하시겠습니까?',
  MALL_ALERT: '페이지 이동 시 변경된 내용은 저장되지 않습니다. 저장하지 않고 이동하시겠습니까?',

  CATEGORY_NO: '카테고리번호',
  CATEGORY_DEPTH1: '1depth',
  CATEGORY_DEPTH2: '2depth',
  CATEGORY_DEPTH3: '3depth',
  CATEGORY_DEPTH4: '4depth',
  CATEGORY_RATE: '수수료(%)',
  FULLNAME: '전체 카테고리명',
  DISPLAYORDER: '카테고리 노출순서',
  DISPLAYCODE: '코드',
  ORIGINTYPE: '원시유형'
});
